var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,null,{
      updateFilters: _vm.updateFilters,
      filters: _vm.filters,
    })],2)}
var staticRenderFns = []

export { render, staticRenderFns }